import { CIcon } from '~/icons/types'

export const ciCross: CIcon = {
  width: 18,
  height: 18,
  paths: [{ d: 'M8.68 1v16M17 9.32H1' }],
  ellipses: [],
  circles: [],
  name: 'cross',
  type: 'regular'
}
